import { RouteElement } from "../interfaces/routes/route-element";

export const routesV3: Record<string, RouteElement> = {
    'systemerror': {
        route: '/system-notification',
        selector: 'system-notification',
        parentMenu: '',
        children: {}
    },
    'login': {
        route: '/login',
        selector: 'login',
        parentMenu: '',
        children: {}
    },
    'loginnyc': {
        route: '/login-nyc',
        selector: 'login-nyc',
        parentMenu: '',
        children: {}
    },
    'activate': {
        route: '/activate/district/:districtId',
        selector: 'activate/district/:districtId',
        parentMenu: '',
        children: {}
    },
    'forbidden': {
        route: '/forbidden',
        selector: 'forbidden',
        parentMenu: '',
        children: {}
    },
    'cloudapps': {
        route: '/cloudapps',
        selector: 'cloudapps',
        regExp: /^\/cloudapps$/,
        parentMenu: '',
        children: {
            'checkrole': {
                route: '/cloudapps/district-check',
                selector: 'district-check',
                parentMenu: '',
                regExp: /^\/cloudapps\/district-check$/,
                children: {}  
            },
            'district': {
                route: '/cloudapps/district',
                selector: 'district',
                regExp: /^\/cloudapps\/district$/,
                parentMenu: 'district',
                children: {
                    'manage': {
                        route: '/cloudapps/district/:districtId/manage',
                        selector: 'manage',
                        regExp: /^\/cloudapps\/district\/([^\/]+)\/manage$/,
                        children: {},
                        parentMenu: 'district',
                    },
                    'settings': {
                        route: '/cloudapps/district/:districtId/settings',
                        selector: 'settings',
                        regExp: /^\/cloudapps\/district\/([^\/]+)\/settings$/,
                        children: {},
                        parentMenu: 'district',
                    },
                    'usage': {
                       route: '/cloudapps/district/:districtId/usage',
                       selector: 'usage',
                       regExp: /^\/cloudapps\/district\/([^\/]+)\/usage$/,
                       children: {},
                       parentMenu: 'district',
                    },
                    'reports': {
                       route: '/cloudapps/district/:districtId/reports',
                       selector: 'reports',
                       regExp: /^\/cloudapps\/district\/([^\/]+)\/reports$/,
                       children: {},
                       parentMenu: 'district'
                    }
                }
            },
            'school': {
                route: '/cloudapps/school',
                selector: 'school',
                regExp: /^\/cloudapps\/school$/,
                parentMenu: 'school',
                children: {
                    'manage': {
                        route: '/cloudapps/school/:schoolId/manage',
                        selector: 'manage',
                        regExp: /^\/cloudapps\/school\/([^\/]+)\/manage$/,
                        children: {},
                        parentMenu: 'school',
                    },
                    'usage': {
                        route: '/cloudapps/school/:schoolId/usage',
                        selector: 'usage',
                        regExp: /^\/cloudapps\/school\/([^\/]+)\/usage$/,
                        children: {},
                        parentMenu: 'school',
                    },
                    'settings': {
                        route: '/cloudapps/school/:schoolId/settings',
                        selector: 'settings',
                        regExp: /^\/cloudapps\/school\/([^\/]+)\/settings$/,
                        children: {},
                        parentMenu: 'school',
                    },
                     'reports': {
                       route: '/cloudapps/school/:schoolId/reports',
                       selector: 'reports',
                       regExp: /^\/cloudapps\/school\/([^\/]+)\/reports$/,
                       children: {},
                       parentMenu: 'school',

                    }
              }
            },
            'class': {
                route: '/cloudapps/school/:schoolId/classes',
                selector: 'classes',
                regExp: /^\/cloudapps\/school\/([^\/]+)\/classes$/,
                parentMenu: 'class',
                children: { 
                     'create': {
                        route: '/cloudapps/school/:schoolId/classes/create',
                        selector: 'create',
                        regExp:  /^\/cloudapps\/school\/([^\/]+)\/classes\/create$/,
                        children: {},
                        parentMenu: 'class',
                    },                   
                    'manage': {
                        route: '/cloudapps/school/:schoolId/classes/:classId/manage',
                        selector: 'manage',
                        regExp: /^\/cloudapps\/school\/([^\/]+)\/classes\/([^\/]+)\/manage$/,
                        children: {},
                        parentMenu: 'class',
                    },
                    'usage': {
                        route: '/cloudapps/school/:schoolId/classes/:classId/usage',
                        selector: 'usage',
                        regExp: /^\/cloudapps\/school\/([^\/]+)\/classes\/([^\/]+)\/usage$/,
                        children: {},
                        parentMenu: 'class',
                    },
                    'settings': {
                        route: '/cloudapps/school/:schoolId/classes/:classId/settings',
                        selector: 'settings',
                        regExp: /^\/cloudapps\/school\/([^\/]+)\/classes\/([^\/]+)\/settings$/,
                        children: {},
                        parentMenu: 'class',
                    }
                }
            }
        }
    }
};